import React, { useEffect, useState } from "react";
import { useSearch } from "wouter";
import { confirmMember } from "@/api/teams";
import { navigate } from "wouter/use-browser-location";
import { ErrorCode } from "@boxem/core-api-schema";
import styles from "../PlanLayout.module.css";
import TextLogo from "@/components/TextLogo/TextLogo";
import Flex from "@/components/Flex/Flex";
import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner";
import { NotificationType, useNotificationContext } from "@/contexts/NotificationContext";
import { parseJwt } from "@/lib/api";

export default function AssistantPage() {
  const searchParams = new URLSearchParams(useSearch());
  const [isLoading, setIsLoading] = useState(true);
  const { showNotification } = useNotificationContext();

  useEffect(() => {
    setIsLoading(true);
    const token = searchParams.get("token");
    //console.log('token: ', token);
    if (!!token) {
      const parsed = parseJwt(token);
      confirmMember(token).then(() => {
        showNotification("You have successfully registered!", NotificationType.SUCCESS);
        setIsLoading(false);
        let url = `/auth/login`;
        if (parsed && parsed.email) {
          url += `?autofillEmail=${encodeURIComponent(parsed.email)}`;
        }
        navigate(url);
      })
      .catch((err) => {
        //console.log(err);
        const msg = err[0]?.type === ErrorCode.TOKEN_EXPIRED ? 'Your token has expired. Please ask the user to resend the invite.' : "Something wrong happend. Please try again later.";
        showNotification(msg, NotificationType.ERROR);
        setIsLoading(false);
      })
    }
    else {
      showNotification("Invalid parameter. Please register with the correct link", NotificationType.ERROR);
      setIsLoading(false);
    }
  }, [])


  return (
    <main className={styles.main}>
      <div className={styles.header}>
        <div className={styles.logo}>
          <TextLogo />
        </div>
        
      </div>
      <Flex>
        <div style={{marginTop: "20px", fontSize: "1.2rem"}}>Thanks for accepting the invite. You are being registered. Please wait a moment...</div>
        {isLoading && <LoadingSpinner />}
      </Flex>

      <div className={styles.footer}>
        <div className={styles.row}>
          <div className={styles.item}>
            <span>© Boxem</span>
          </div>
          <div className={styles.item}>
            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" viewBox="0 0 2 2" fill="none">
              <circle cx="1" cy="1" r="1" fill="var(--static-text-weak)" />
            </svg>
          </div>
          <div className={styles.item}>
            <span>Contact</span>
          </div>
        </div>
      </div>
    </main>
  );
}
